var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Overview',{attrs:{"name":"Feed type","hide-add":""}},[_c('LelyTable',{attrs:{"items":_vm.feedTypes,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }